import * as Yup from 'yup';
import { Switch } from '../../../../../../shared/types/modules/switch';

export const initialValues: Switch = {
    callId: '',
    channel: '',
    typification1: '',
    typification2: '',
    official: '',
    ext: '',
    observation: '',
    isTransferAssistance: false,
    document: '',
    vehiclePlate: '',
    policyNumber: '',
    branch: '',
};

export const validationSchema = (
    requireTypification2: boolean,
    isTracking: boolean,
    isAutomobilesTypification: boolean,
    avisoSiniestroTypification2Id?: string
) => {
    const schema: any = {
        callId: Yup.string().max(
            100,
            'El call ID debe tener 100 caracteres alfanuméricos como máximo'
        ),
        channel: Yup.string().required('El canal es obligatorio'),
        typification1: Yup.string().required(
            'La tipificación 1 es obligatoria'
        ),
        observation: Yup.string().required('La observación es obligatoria'),
    };

    if (requireTypification2)
        schema.typification2 = Yup.string().required(
            'La tipificación 2 es obligatoria'
        );
    if (isTracking) {
        schema.document = Yup.string().when('typification2', {
            is: (typification2: string) =>
                isAutomobilesTypification &&
                Boolean(avisoSiniestroTypification2Id) &&
                typification2 === avisoSiniestroTypification2Id,
            then: (fieldSchema: Yup.StringSchema) =>
                fieldSchema.required('Número de documento es obligatorio'),
            otherwise: (fieldSchema: Yup.StringSchema) => fieldSchema,
        });
        schema.vehiclePlate = Yup.string().when('typification2', {
            is: (typification2: string) =>
                isAutomobilesTypification &&
                Boolean(avisoSiniestroTypification2Id) &&
                typification2 === avisoSiniestroTypification2Id,
            then: (fieldSchema: Yup.StringSchema) =>
                fieldSchema.required('Placa es obligatoria'),
            otherwise: (fieldSchema: Yup.StringSchema) => fieldSchema,
        });
        schema.policyNumber = Yup.string().when('typification2', {
            is: (typification2: string) =>
                isAutomobilesTypification &&
                Boolean(avisoSiniestroTypification2Id) &&
                typification2 === avisoSiniestroTypification2Id,
            then: (fieldSchema: Yup.StringSchema) =>
                fieldSchema.required('Número de póliza es obligatorio'),
            otherwise: (fieldSchema: Yup.StringSchema) => fieldSchema,
        });
        schema.branch = Yup.string().required(
            'La sucursal es obligatoria'
        );
    }

    return Yup.object(schema);
};
